import React from 'react';
import './Experience.css';

const EXPERIENCES = [
  {
    role: 'Product Manager',
    company: 'Roblox',
    team: 'Payments & Developer Monetization',
    period: 'Present',
    description: 'Building the economic layer that powers the Roblox ecosystem — making it easier for creators to earn and for players to pay.',
  },
];

const EDUCATION = [
  {
    school: 'University of California, Berkeley',
    degrees: 'B.S. Computer Science, B.S. Business Administration',
  },
];

function Experience() {
  return (
    <main className="experience section">
      <div className="container">
        <h1 className="page-title">Experience</h1>
        <p className="subtitle" style={{ marginBottom: 'var(--space-2xl)' }}>
          Where I've worked and what I focus on.
        </p>
        <ul className="experience-list">
          {EXPERIENCES.map((job, i) => (
            <li key={i} className="experience-item">
              <div className="experience-header">
                <div>
                  <span className="experience-role">{job.role}</span>
                  <span className="experience-company"> — {job.company}</span>
                </div>
                <span className="experience-period">{job.period}</span>
              </div>
              {job.team && (
                <p className="experience-team">{job.team}</p>
              )}
              <p className="experience-desc">{job.description}</p>
            </li>
          ))}
        </ul>

        <h2 className="experience-section-title">Education</h2>
        <ul className="experience-list">
          {EDUCATION.map((edu, i) => (
            <li key={i} className="experience-item">
              <div className="experience-header">
                <span className="experience-role">{edu.school}</span>
              </div>
              <p className="experience-desc">{edu.degrees}</p>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}

export default Experience;
